import { fetchData } from "@request";

export type EarnBalance = {
  amount: number;
  pay_in: number;
  pay_out: number;
};

export interface MerchantBalance {
  sum_rub: number;
  sum_usdt: number;
  ern_balance: EarnBalance;
}

export type MerchantPayoutForm = {
  address: string;
  amount: number;
  network: string;
};

export const getMerchantBalancesApi = async (userId: string) => {
  try {
    const response = await fetchData<MerchantBalance>({
      url: `api/v1/merchant/balances/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Balances failed:", error);
    throw error;
  }
};
